import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { Observable } from 'rxjs';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';

@Component({
    selector: 'kx-patient-view-queue',
    templateUrl: './patient-view-queue.component.html',
    styleUrls: ['./patient-view-queue.component.scss'],
    standalone: false
})
export class PatientViewQueueComponent implements OnInit {
  queue: any;
  Arr = [1, 2, 3, 4, 5];
  @Input() id: any; waitingTime=0;
  @Input() resource: any;
  showQueue: boolean = true;
  showbackButton: boolean = false;
  showMessage: boolean = false;

  constructor(
    private Aroute: ActivatedRoute,
    private route: Router,
    private baseService: BaseService,
    private loader: LoaderService,
    public utilService: UtilService,
    private alert: AlertsService
  ) { }

  ngOnInit() {
    this.getOrderDetails()
    this.baseService.setTitle("pa.vq");
    this.baseService.backNavigation = true;
  }

  getOrderDetails() {
    if (this.id == undefined) {
      this.Aroute.params.subscribe((res) => {
        this.orderDetails(res.id, res.resource)
      })
      this.Aroute.queryParams.subscribe((res) => {
        if (res.hasOwnProperty('returnUrl'))
          this.showbackButton = true
      })
    } else {
      this.orderDetails(this.id, this.resource)
    }


  }

  orderDetails(id: any, source: any) {
    this.returnOrderDetails$(id).subscribe((order: any) => {
      this.baseService.getResourceDef(source, (resourceDef) => {
        if (resourceDef) {
          // debugger;
          this.checkPatientQueueMapping(order, resourceDef)
        }
      })
    })
  }

  checkPatientQueueMapping(order, resourceDef) {
    this.baseService.get("GET_PAGE", "facility_id:"+order.resource[0].facility_id, "queue_master_slot_base_queue_main", "facility-management", "doctor_id:" + order.resource[0].participant_details[0].participantId).subscribe((res: any) => {
      if (res.errCode == 0 && res.resource.length == 1) {
        this.patientQueue(order.resource[0], resourceDef)
      }else {
        this.checkQueueDeskMapping(order, resourceDef)
      }
    })
  }

  calculateWaitingTime(waitingTime: number): string {
    waitingTime = Math.floor(waitingTime); // Round down to the nearest whole number
    waitingTime = Math.max(waitingTime, 0); // Ensure waiting time is not negative
    waitingTime = Math.min(waitingTime, 999); // Cap waiting time at 999 minutes
    waitingTime = Math.round(waitingTime); // Round to the nearest whole number
    waitingTime = waitingTime * (this.queue[0]?.pending_in_queue+1); // Multiply by the number of people in the queue
    if (waitingTime < 60) {
      return `${waitingTime} min`;
    } else {
      const hours = Math.floor(waitingTime / 60);
      const minutes = waitingTime % 60;
      return `${hours} hr ${minutes} min`;
    }
  }

  checkQueueDeskMapping(order, resourceDef) {
    this.baseService.get("GET_TOKEN_WITH_DESK_STATUS", "facility_id:" + order.resource[0].facility_id+",uhId:" + order.resource[0].uhId + ",serviceDate:" + order.resource[0].serviceDate + ",desk_user_id:" + order.resource[0].participant_details[0].participantId + ",serviceType_code:op_consulation", "queue_desk_mapping", "queue-management").subscribe((res: any) => {
      if (res.errCode == 0 && res.resource.length == 1) {
        this.waitingTime = res.resource[0]?.extra_data?.waiting_time;
        this.patientQueue(order.resource[0], resourceDef)
      } else {
        this.alert.error(res.message);
      }
    })
  }

  returnOrderDetails$(id: any): Observable<any> {
    return this.baseService.get("GET_BY_ID", "id:" + id, "service_request", "order");
  }

  getPatientQueue$(query_Id, args: any, resource: any, application: any): Observable<any> {
    return this.baseService.get(query_Id, args, resource, application);
  }

  patientQueue(order: any, resourceDef: any) {
    this.loader.showSpinner();
    var args = ""
    if (order.practice_type_code == "individual") {
      args = "practitioner_id:" + order.participant_details[0].participantId + ",serviceItemCode:" + order[this.returnCondition(resourceDef, order).args.serviceItemCode] + ",slot_date:" + order[this.returnCondition(resourceDef, order).args.slot_date] + ",slotStartTime:" + order[this.returnCondition(resourceDef, order).args.slotStartTime] + ",status:" + order[this.returnCondition(resourceDef, order).args.status] + ",facility_id:" + order[this.returnCondition(resourceDef, order).args.facility_id] + ",uhId:" + order["uhId"]
    } else {
      args = "token_no:" + order[this.returnCondition(resourceDef, order).args.token_no] + ",slotDate:" + order[this.returnCondition(resourceDef, order).args.serviceDate] + ",facility_id:" + order[this.returnCondition(resourceDef, order).args.facility_id]
    }
    this.getPatientQueue$(this.returnCondition(resourceDef, order).query_id, args, this.returnCondition(resourceDef, order).resource, this.returnCondition(resourceDef, order).application).subscribe((res: any) => {
      if (res) {
        this.loader.hideSpinner();
        if (res.errCode == 0) {
          this.queue = res.resource;
          if (this.queue && order.practice_type_code == "individual") {
            if (this.queue[0].pending_in_queue > 5) {
              this.showQueue = false
            }
          } else {
            if (this.queue[0].extra_data.pending_in_queue > 5) {
              this.showQueue = false
            }
          }
        } else {
          this.alert.error(res.message);
          this.showMessage = true;
        }
      }
    })
  }

  returnCondition(resourceDef: any, order) {
    return order.practice_type_code == "individual" ? resourceDef.capability.find(x => (x.label == "button.view_queue_patient")).datasource : resourceDef.capability.find(x => (x.label == "button.view_queue_patient_group")).datasource
  }

  previous() {
    this.route.navigate(["order/my_orders_format/orderList"])
  }

  getDoctorInitials(doctorName: string): string {
    const parts = doctorName?.trim().split(' ').filter(Boolean) || [];
    if (!parts.length) {
      return '';
    }
    const first = parts.length > 1 ? parts[1]?.[0] : parts[0]?.[0];
    const last = parts[parts.length - 1]?.[0];
    return `${first || ''}${last || ''}`;
  }

}
